//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Multiselect from 'vue-multiselect'
import SupervisorValidationTable from './SupervisorValidation/SupervisorValidationTable.vue'
import ModalValidatedSkills from './SupervisorValidation/ModalValidatedSkills.vue'

export default {
  name: 'SupervisorsValidationTab',
  components: {
    SupervisorValidationTable,
    Multiselect,
    ModalValidatedSkills,
  },
  props: {
    project: {
      type: Object,
      default: () => ({}),
    },
  },
  async fetch() {
    this.$store.commit('loading', true)
    this.supervisors = await this.$repository.user.findSupervisorsByProject({
      project: this.project.id,
    })
    this.collaboratorsMetrics = await this.$repository.supervisorAssignments.getCollaboratorValidationMetricsByProjectId(
      this.project.id
    )
    this.$store.commit('loading', false)
  },
  data() {
    return {
      filters: {
        term: '',
        supervisor: null,
      },
      supervisors: [],
      collaboratorsMetrics: [],
      isShowModalValidatedSkills: false,
      skillsValidationsWithUsers: {},
    }
  },
  computed: {
    formattedCollaborators() {
      return this.collaboratorsMetrics
        .filter((collaborator) => {
          const termMatch = collaborator.collaborator
            .toLowerCase()
            .includes(this.filters.term.toLowerCase())
          const supervisorMatch =
            !this.filters.supervisor ||
            collaborator.supervisor_id === this.filters.supervisor.value
          return termMatch && supervisorMatch
        })
        .map((collaborator) => ({
          ...collaborator,
          disparity: Number(
            (
              Number(collaborator.supervisor_match) -
              Number(collaborator.collaborator_match)
            ).toFixed(2)
          ),
        }))
    },
    supervisorsFormatted() {
      return this.supervisors.map((supervisor) => ({
        value: supervisor.id,
        label: `${supervisor.names} ${supervisor.lastnames}`,
      }))
    },
  },
  methods: {
    toggleModalValidatedSkills() {
      this.isShowModalValidatedSkills = !this.isShowModalValidatedSkills
    },
    async handleSkillsValidations(supervisorAssignment) {
      this.skillsValidationsWithUsers = await this.$repository.skillsValidations.findSkillsValidatedDetailBySupervisorAssignmentId(
        supervisorAssignment.id
      )
      this.isShowModalValidatedSkills = true
    },
  },
}
